'use client';

import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';
import type { JSX } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { Icon } from '@/components/ui/icon';
import { BubbleChatQuestionIcon } from '@/components/ui/icon/glyphs';
import { env } from '@/lib/config/env';
import { stripDemoModePath } from '@/lib/network';
import { openSupport, useSupportStore } from '@/stores/support';

export function SupportLauncher(): JSX.Element | null {
  const t = useTranslations();
  const pathname = stripDemoModePath(usePathname());
  const status = useSupportStore((state) => state.status);
  const appId = env.NEXT_PUBLIC_INTERCOM_APP_ID;
  if (
    appId === undefined ||
    appId === '' ||
    status === 'ready' ||
    pathname === '/workspace/pattern' ||
    pathname.startsWith('/workspace/pattern/')
  ) {
    return null;
  }

  const loading = status === 'loading';
  return (
    <AnimatedButton
      data-testid="support-launcher"
      className="fixed right-5 bottom-5 z-toast hidden rounded-full shadow-elevation-card lg:inline-flex"
      size="xl"
      aria-label={loading ? t('support.loading') : t('footer.support')}
      disabled={loading}
      loading={loading}
      onClick={openSupport}
    >
      <Icon icon={BubbleChatQuestionIcon} />
    </AnimatedButton>
  );
}
